import { useState } from "react"

const KEY = "sidebar-digital-time-visible"

export function useSidebarDigitalTime(): [boolean, () => void] {
  const [show, setShow] = useState(() => localStorage.getItem(KEY) !== "false")
  const toggle = () => {
    setShow((v) => {
      const next = !v
      localStorage.setItem(KEY, String(next))
      return next
    })
  }
  return [show, toggle]
}
